import urlApi from './urlApi';
export var USER_INFO_INFO_REQUEST = 'USER_INFO_INFO_REQUEST';
export var USER_INFO_INFO_SUCCESS = 'USER_INFO_INFO_SUCCESS';
export function getUserFP(fp, device, browser, ip, data) {
    return function (dispatch) {
        dispatch({
            type: USER_INFO_INFO_REQUEST,
        });
        var currUserId = localStorage.getItem('userId') || '';
        var currClientId = localStorage.getItem('clientId') || '';
        urlApi().getUserFP(fp, device, browser, ip, data, currUserId, currClientId).then(function (res) {
            if (res.status === 200) {
                dispatch({
                    type: USER_INFO_INFO_SUCCESS,
                    payload: res.data,
                });
                if (currUserId !== res.data.userId && currUserId !== '') {
                    // console.log('имя юзера изменилось!')
                }
                if (currClientId !== res.data.clientId && currClientId !== '') {
                    // console.log('имя клиента изменилось!')
                }
                localStorage.setItem('userId', res.data.userId);
                localStorage.setItem('clientId', res.data.clientId);
                localStorage.setItem('isReg', res.data.isRegistred);
            }
        });
    };
}
//# sourceMappingURL=getUserFP.js.mapimport urlApi from './urlApi';
export var USER_INFO_INFO_REQUEST = 'USER_INFO_INFO_REQUEST';
export var USER_INFO_INFO_SUCCESS = 'USER_INFO_INFO_SUCCESS';
export function getUserFP(fp, device, browser, ip, data) {
    return function (dispatch) {
        dispatch({
            type: USER_INFO_INFO_REQUEST,
        });
        var currUserId = localStorage.getItem('userId') || '';
        var currClientId = localStorage.getItem('clientId') || '';
        urlApi().getUserFP(fp, device, browser, ip, data, currUserId, currClientId).then(function (res) {
            if (res.status === 200) {
                dispatch({
                    type: USER_INFO_INFO_SUCCESS,
                    payload: res.data,
                });
                if (currUserId !== res.data.userId && currUserId !== '') {
                    // console.log('имя юзера изменилось!')
                }
                if (currClientId !== res.data.clientId && currClientId !== '') {
                    // console.log('имя клиента изменилось!')
                }
                localStorage.setItem('userId', res.data.userId);
                localStorage.setItem('clientId', res.data.clientId);
                localStorage.setItem('isReg', res.data.isRegistred);
            }
        });
    };
}
//# sourceMappingURL=getUserFP.js.map